/**
 * Created by mac on 1/10/23
 */

const AboutWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const business = (connector.config[connector.info.source] || {}).business || connector.config.business;
        const termsConfig = connector.config.terms[business];

        const company = { ...AboutWindow.DEFAULT_COMPANY, ...termsConfig.company };
        const fillCompany = (template) => template.replace(/\{(\w+)\}/g, (match, key) => (company[key] !== undefined ? company[key] : match));

        const links = [
            {
                button: Messages.get("AboutWindow.terms"),
                url: termsConfig.terms,
                text: fillCompany(termsText[connector.info.source] || termsText.default)
            },
            {
                button: Messages.get("AboutWindow.privacy"),
                url: termsConfig.privacy,
                text: fillCompany(privacyText[connector.info.source] || privacyText.default)
            }
        ];

        const styles = cleverapps.styles.AboutWindow;

        const buttons = links.map((link) => new cleverapps.UI.Button({
            text: link.button,
            onClicked: () => {
                if (connector.platform.oneOf(connector.WECHAT, connector.INSTANT, connector.DISCORD, connector.SAMSUNG)) {
                    cleverapps.focusManager.display({
                        focus: "PrivacyWindow",
                        stack: true,
                        action: (f) => {
                            new PrivacyWindow(link.button, link.text);
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                } else {
                    connector.platform.openUrl(link.url);
                }
            },
            width: styles.button.width,
            height: styles.button.height
        }));

        const buttonsBlock = cleverapps.resolution.isVertical() ? buttons : new cleverapps.Layout(buttons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.button.margin
        });

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get("AboutWindow.text", {
            version: cleverapps.config.version,
            gameTitle: Messages.get(cleverapps.config.name)
        }), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.size[cleverapps.resolution.mode].width, 0);

        const deleteAccountButton = this.createDeleteAccountButton();

        const textBlock = cleverapps.UI.wrapWithPadding(text, styles.text.padding);
        let content = new cleverapps.Layout([textBlock, buttonsBlock, deleteAccountButton].flat().filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        content = cleverapps.UI.wrapWithPadding(content, styles.padding);

        this._super({
            title: Messages.get("AboutWindow.title"),
            name: "aboutwindow",
            content
        });
    },

    createDeleteAccountButton: function () {
        if (!cleverapps.userDelete.isAvailable()) {
            return;
        }

        const styles = cleverapps.styles.AboutWindow.button;

        return new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("DeleteAccount"),
            onClicked: () => {
                cleverapps.focusManager.display({
                    focus: "DeleteAccountWindow",
                    stack: true,
                    action: (f) => {
                        new DeleteAccountWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            },
            width: styles.width,
            height: styles.height
        });
    }
});

AboutWindow.DEFAULT_COMPANY = {
    name: "Clever Apps",
    legalName: "Clever Apps Pte. Ltd.",
    address: "8 Marina Boulevard #11-00 Marina Bay Financial Centre Singapore 018981",
    registration: "201706967K",
    jurisdiction: "Singapore",
    privacyEmail: "help.cleverapps+privacy@gmail.com",
    supportEmail: "vtbelo+support@gmail.com"
};

cleverapps.styles.AboutWindow = {
    margin: 30,

    padding: {
        bottom: 20
    },

    text: {
        size: [{
            width: 700
        }, {
            width: 1100
        }, {
            width: 1100
        }],

        padding: {
            x: 20,
            y: 20
        }
    },

    button: {
        width: 560,
        height: 110,
        margin: 100
    }
};